<template>
  <div>
    <div
      :class="$style.image"
      class="height-250 mb-3 justify-content-center"
    >
      <ImageView
        :image="activeImage"
        alt="Product"
        height="250px"
        width="auto"
      />
    </div>
    <div class="d-flex flex-wrap mb-3 justify-content-center">
      <a
        v-for="(image, index) in images"
        :key="index"
        href="#"
        :class="[index === activeImgIndex ? 'border-primary' : '', $style.thumb]"
        class="width-100 height-100 border mr-2 mb-2"
        @click.prevent="activeImgIndex = index"
      >
        <ImageView
          :image="image"
          height="100%"
          width="100%"
        />
      </a>
    </div>
  </div>
</template>

<script>
import ImageView from '@/components/common/ImageView'
export default {
  name: 'ProductGalleryView',
  components: { ImageView },
  props: {
    images: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      activeImgIndex: 0,
    }
  },
  computed: {
    activeImage () {
      return this.images[this.activeImgIndex]
    },
  },
  methods: {
    setImage (imageIndex) {
      this.activeImgIndex = imageIndex
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
